var map = {
	"./NaturesEn.js": 1851,
	"./NaturesEs.js": 6880,
	"./NaturesEsLa.js": 4651,
	"./NaturesFre.js": 8457,
	"./NaturesGer.js": 6584,
	"./NaturesIta.js": 7534
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6860;
module.exports = webpackAsyncContext;